import * as React from 'react';
import * as Tgcc from '../tgccGlobal'
import {connect} from 'react-redux';
import {CSSProperties} from 'react';
import {CampusProofCard} from './CampusProofCard';
import {Button} from '../Components/Button';
import {CampusFrontLocator} from '../TextEdit/CampusFrontLocator';
import {CampusBackLocator} from '../TextEdit/CampusBackLocator';
import {TextEditPopup} from '../TextEdit/TextEditPopup';


class Props extends Tgcc.BaseProps{
    frontText: string;
    backText: string;
    frontLocation: string;
    backLocation: string;
    Notes:string;
}

const iconFrontStyle : CSSProperties = {
    backgroundColor: 'transparent',
    height: '17px',
    display: 'flex',
    alignSelf: 'center',
    marginBottom: '2px',
    marginTop: '-4px'
}

const iconBackStyle : CSSProperties = {
    backgroundColor: 'transparent',
    height: '17px',
    display: 'flex',
    alignSelf: 'center',
    marginBottom: '2px',
    marginTop: '2px'
}

const textStyle : CSSProperties  = {
    fontFamily: 'BarlowLight',
    fontSize: '16px',
    textAlign: 'center',
    alignSelf: '',
    border: '1px solid #E9E6E6',
    borderSpacing: 0,
    height: '60px',
    width: '290px',
    resize: 'none',
    overflowY: 'hide',
    overflowX: 'auto',
    cursor: 'pointer',
    color:'#616060',
}

const innerCont: CSSProperties = {
    textAlign:'center'
}
const step: CSSProperties = {
    textAlign:'center',
    textTransform:'uppercase',
    fontFamily:'Lulo',
    fontSize:'20px'
}
const printBtnStyle: CSSProperties = {
    backgroundColor:'#616060',
    color:'white',
    width:'254px',
    height:'25px',
    margin:'auto',
    lineHeight:'2.2em',
    fontFamily:'Lulo',
    fontSize:'11px',
    cursor:'pointer'
}

const text: React.CSSProperties = {
    fontFamily:'Reitam',
    color:'#616060',
    fontSize:'14px'
}
const inputStyle : CSSProperties = {
    fontFamily: 'BarlowLight',
    fontSize: '16px',
    margin: '10px auto',
    border: '1px solid #A7A7A7',
    boderSpacing: 0,
    height: '100px',
    width: '290px',
    resize: 'none',
    overflowY: 'hide',
    overflowX: 'auto'
}
const anything: CSSProperties = {
    fontFamily: "Reitam",
    marginTop:'12px'
}
let emptyNotesStyle = Object.assign({},inputStyle,{textAlign: 'center', color: 'darkgray', overflow: 'hidden'});

class _CampusTextEdit extends React.Component<Props, any>{

    state = {
        Notes: "",
    };

    componentWillMount(){
        this.setState({Notes: this.props.Notes});
    }
    componentWillReceiveProps(newProps: Props){
        this.setState({Notes: newProps.Notes});
    }
    editFrontText = () => {
        this.props.dispatch({ type: Tgcc.StateAction.SetEditState, payload: Tgcc.EditStates.EditFrontText})
    }
    setFrontText = (text: string) => {
        this.props.dispatch({type: Tgcc.StateAction.SetFrontText, payload: text})
    }

    editBackText = () => {
        this.props.dispatch({ type: Tgcc.StateAction.SetEditState, payload: Tgcc.EditStates.EditBackText})
    }
    setBackText = (text: string) => {
        this.props.dispatch({type: Tgcc.StateAction.SetBackText, payload: text})
    }
    emptyClick = (evt: React.SyntheticEvent<HTMLTextAreaElement>) =>{
        evt.currentTarget.value = "";
    }
    emptyBlur = (evt: React.SyntheticEvent<HTMLTextAreaElement>) =>{
    }
    editStart = (evt: React.SyntheticEvent<HTMLTextAreaElement>) =>{
        this.noteChanged(evt);
    }
    noteChanged = (evt: React.SyntheticEvent<HTMLTextAreaElement>) => {
        this.props.dispatch({type: Tgcc.StateAction.UpdateProofNotes, payload: evt.currentTarget.value});
    }
    getLocationButton(text: string, imgSrc: string, selector: ()=>void){
        var btnStyle: CSSProperties = {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '30px',
            padding: '3px',
            cursor: 'pointer'
        }
        var imgStyle: CSSProperties = {
            display: 'flex',
            alignSelf: 'center',
            height: '100%'
        }
        var txtStyle: CSSProperties = {
            display: 'flex',
            alignSelf: 'center',
            fontSize: '10px',
            textTransform: 'uppercase',
            fontFamily: 'CenturyGothic',
            backgroundColor: Tgcc.Styles.inputBackground,
            margin: "0 5px",
            padding: "2px 10px"
        }
        return (
            <div className="hoverBorder" style={btnStyle} onClick={selector}>
                <img src={imgSrc} style={imgStyle}/>
                <div style={txtStyle}>{text}</div>
            </div>
        )
    }

    getFrontLocationButton(){
        var defaultBtn = (<div style={printBtnStyle} onClick={this.selectFrontLocation}>CHOOSE FRONT LOCATION</div>);
        var txt: string;
        var img: string;
        switch(this.props.frontLocation){
            case Tgcc.FrontLocations.FrontLeftorPocket:
                return this.getLocationButton("front left/pocket", Tgcc.ResolveUrl('~/images/Left.Pocket.png'), this.selectFrontLocation);
            case Tgcc.FrontLocations.SmallFront:
                return this.getLocationButton("small front", Tgcc.ResolveUrl('~/images/Small.Front.png'), this.selectFrontLocation);
            case Tgcc.FrontLocations.MediumFront:
                return this.getLocationButton("medium front", Tgcc.ResolveUrl('~/images/Medium.Front.png'), this.selectFrontLocation);
            case Tgcc.FrontLocations.FullFront:
                return this.getLocationButton("full front", Tgcc.ResolveUrl('~/images/Full.Front.png'), this.selectFrontLocation);
            case Tgcc.FrontLocations.None: 
            default: 
                return defaultBtn;
        }
    }

    getBackLocationButton(){
        var defaultBtn = (<div style={printBtnStyle} onClick={this.selectBackLocation}>CHOOSE BACK LOCATION</div>);
        switch(this.props.backLocation){
            case Tgcc.BackLocations.SmallBack:
                return this.getLocationButton("small back",Tgcc.ResolveUrl('~/images/Small.Front.png'), this.selectBackLocation);
            case Tgcc.BackLocations.MediumBack:
                return this.getLocationButton("medium back",Tgcc.ResolveUrl('~/images/Medium.Front.png'), this.selectBackLocation);
            case Tgcc.BackLocations.FullBack:
                return this.getLocationButton("full back",Tgcc.ResolveUrl('~/images/Full.Front.png'), this.selectBackLocation);
            case Tgcc.BackLocations.None: 
            default:
                return defaultBtn;            
        }
    }

    render(){
        var frontText: string = this.props.frontText ? this.props.frontText : "";
        var backText: string = this.props.backText ? this.props.backText : "";
        var notes = this.state.Notes || '';
        var textEdit = notes ? 
                    <textarea name="existingNotes"
                        className="hoverBorder"
                        style={inputStyle}
                        value={notes}
                        onChange={this.noteChanged}>
                    </textarea>
                    :
                    <textarea
                        name="emptyNotes"
                        className="hoverBorder"
                        style={emptyNotesStyle}
                        onClick={this.emptyClick}
                        onChange={this.editStart}
                        placeholder="Leave the artist or your account manager any notes here:"></textarea>

        return (
        <div>
            <div style={step}>Step 2 </div>
            <CampusProofCard title="CUSTOMIZE" margin='0px 10px' containerHeight='470px' containerWidth='375px'  innerHeight='402px' innerWidth='335px'>
                <div style={innerCont}>
                    <div style={text}>Front</div>
                    <textarea className="hoverBorder" readOnly={true}  style={textStyle} onClick={this.editFrontText} value={frontText} placeholder="Tell us what you want on the front of the shirt"/>
                    {this.getFrontLocationButton()}
                    <div style={text}>Back</div>
                    <textarea className="hoverBorder" readOnly={true}  style={textStyle} onClick={this.editBackText} value={backText} placeholder="Tell us what you want on the back of the shirt"/>
                    {this.getBackLocationButton()}
                </div>
                <div style={anything}>ANYTHING ELSE WE SHOULD KNOW?</div>
                {textEdit}
            </CampusProofCard>
            <TextEditPopup text={frontText} title="Front Text" editState={Tgcc.EditStates.EditFrontText} addToProof={this.setFrontText} fontFamily='AveriaSerifLightItalic'/>
            <TextEditPopup text={backText} title="Back Text" editState={Tgcc.EditStates.EditBackText} addToProof={this.setBackText} fontFamily='AveriaSerifLightItalic'/>
            <CampusFrontLocator />
            <CampusBackLocator />
        </div>
        )
    }


    selectFrontLocation = () => {
        this.props.dispatch({type: Tgcc.StateAction.SetEditState, payload: Tgcc.EditStates.SelectFrontLocation});
    }

    selectBackLocation = () => {
        this.props.dispatch({type: Tgcc.StateAction.SetEditState, payload: Tgcc.EditStates.SelectBackLocation});
    }

}

const mapStateToProps = (state: Tgcc.GlobalState) => {
    var newProps = { 
        frontText: state.ActiveProof.text.front,
        frontLocation: state.ActiveProof.frontLocation,
        backText: state.ActiveProof.text.back,
        backLocation: state.ActiveProof.backLocation,
        Notes:state.ActiveProof.notes
    };
    return newProps;
};

export var CampusTextEdit = connect(mapStateToProps)(_CampusTextEdit);